import React, { Component } from 'react';
import { Card } from "material-ui/Card";
import { Box, Text } from "rebass";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from "material-ui/Table";

import RaisedButton from 'material-ui/RaisedButton';

import { ViewTitle } from "../components";
import { DivFormContainer, HeaderTitleImport } from './styled';
import ImportButton from './ImportButton';
import { cyan500 } from 'material-ui/styles/colors';

class ImportMarketer extends Component{
  constructor(props){
    super(props)
    this.state ={
      total_kol: 0,
      error: [],
      reload: [],
      total_error: 0
    }
  }

  onUpload(data){
    this.setState({
      total_kol: data.total_kol || 0,
      error: data.error || [],
      total_error: data.error.length || 0
    });
    
  }
  renderFailedLine(){
    const {error} = this.state;
    return(
      <Box w={[1]} p={[1]}>
        <Table selectable={false}>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow style={styles.rowHeader}>
              <TableHeaderColumn style={styles.titleHeader}>Line #</TableHeaderColumn>
              <TableHeaderColumn style={styles.titleHeader}>Content</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {error && error.map((item, index)=>{
              return(
                <TableRow key={index}>
                  <TableRowColumn>{item.line_number}</TableRowColumn>
                  <TableRowColumn>{item.content}</TableRowColumn>
                </TableRow> 
              )
            })}
          </TableBody>
        </Table>
      </Box>  
    )
  }
  renderFailedReload(){
    const {reload} = this.state;
    return(
      <Box w={[1]} p={[1]}>
        <Table selectable={false} headerStyle={{backgroundColor: cyan500}}>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow style={styles.rowHeader}>
              <TableHeaderColumn style={styles.titleHeader}>Number</TableHeaderColumn>
              <TableHeaderColumn style={styles.titleHeader}>Value</TableHeaderColumn>
              <TableHeaderColumn style={styles.titleHeader}>Reason</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
          {reload && reload.map((item, index)=>{
              return(
                <TableRow key={index}>
                  <TableRowColumn>{item.number}</TableRowColumn>
                  <TableRowColumn>{item.value}</TableRowColumn>
                  <TableRowColumn>{item.reason}</TableRowColumn>
                </TableRow> 
              )
            })}
          </TableBody>
        </Table>
      </Box>  
    )
  }
  render(){
    const {total_kol, total_error} = this.state;
    return(
      <Card containerStyle={{ minHeight: 518 }}>
        <ViewTitle
          title={<HeaderTitleImport {...this.props}/>}
        />
        <DivFormContainer w={[1]}>
          <Box w={[1]} p={[1]}>
             <ImportButton agencyid={this.props.match.params.id} onUpload={this.onUpload.bind(this)}/>
          </Box>
          <Box w={[1]} p={[2]}>
            <TextMessage>Total KOL = {total_kol}</TextMessage>
            <TextMessage>Total Errors = {total_error}</TextMessage>
          </Box>  
          <Box w={[1]} px={[2]} pt={[1]}>
            <Text>Failed Line</Text>
          </Box>  
          {this.renderFailedLine()}
          <Box w={[1]} py={[1]} px={[2]}>
            <RaisedButton primary={true} label={"Execute"}/>
          </Box>  
          <Box w={[1]} p={[2]} >
            <TextMessage>Total Processed 0</TextMessage>
          </Box>  
          <Box w={[1]} px={[2]} pt={[1]}>
            <Text>Failed Reload</Text>
          </Box>  
          {this.renderFailedReload()}
        </DivFormContainer>
        
      </Card>
    )
  }
}

const TextMessage = Text.extend`
  padding-bottom: 8px;
  font-size: 12px;
`;

const styles = {
  rowHeader:{
    backgroundColor: cyan500
  },
  titleHeader: {
    color: '#FFFFFF',
    fontSize: '14px'
  }
}

export default ImportMarketer;


// WEBPACK FOOTER //
// ./src/agency/ImportMarketer.js